/**
 * Normalizes city names for consistent matching in the database
 * 
 * Rules:
 * 1. Convert "St." or "st." to "Saint"
 * 2. Remove all special characters and spaces using regex [^a-zA-Z0-9]
 * 3. Convert to lowercase
 * 4. Trim leading/trailing whitespace
 * 
 * Examples:
 * - "St. Louis" → "saintlouis"
 * - "Baton Rouge" → "batonrouge"
 * - "Wilkes-Barre" → "wilkesbarre"
 * - "New York" → "newyork"
 * - "Los Angeles" → "losangeles"
 * - "Pembroke Pines" → "pembrokepines"
 * 
 * @param cityName - The original city name to normalize
 * @returns The normalized city name (lowercase, no spaces/special chars)
 */
export function normalizeCity(cityName: string | null | undefined): string {
  if (!cityName) return '';
  
  return cityName
    .trim()
    .replace(/^St\.?\s+/i, 'Saint')  // Convert "St." or "st." to "Saint" (case-insensitive)
    .replace(/[^a-zA-Z0-9]/g, '')     // Remove all special characters and spaces
    .toLowerCase();                    // Convert to lowercase
}

